(function(module) {
    'use strict';

    module.filter('decodeURIFilter', () => {
        return (txt) => {
            if (window.decodeURIComponent) return window.decodeURIComponent(txt);
            if (window.decodeURI) return window.decodeURI(txt);
            return txt;

        };
    });

    module.filter('trustUrl', ($sce) => {
        return (url) => {
            return $sce.trustAsResourceUrl(url);
        };
    });

})(angular.module('rocket.components'));
